enum DiagnosticCodeType {
    InternationalClassificationOfDiseases_V9 = 0,
    InternationalClassificationOfDiseases_V9_BritishColumbiaOnly = 1,
    InternationalClassificationOfDiseases_V9_MexicoOnly = 2,
    InternationalClassificationOfDiseases_V10 = 3,
    InternationalClassificationOfDiseases_V10_MexicoOnly = 4,
    InternationalClassificationOfPrimaryCare = 5,
    InternationalClassificationOfDiseases_V9_OntarioMinistryOfHealth = 6
}

export { DiagnosticCodeType };
